
//系统列表
export const platformType = [
    {label:'UCENTER',value:'UCENTER'},
    {label:'ASSP',value:'ASSP'},
    {label:'MTDS',value:'MTDS'},
    {label:'WSP',value:'WSP'},
]

//组织类型
export const orgType = [
    {label:'欧派',value:'OPPEIN'},
    {label:'代理商',value:'AGENT'},
    {label:'第三方',value:'OTHER'},
]

//角色来源类型
export const roleType = [
    {label:'职位',value:'POSITION'},
    // {label:'部门',value:'DEPARTMENT'},
].concat(platformType)


//系统日志类型
export const systemLogType = [
    {label:'登录',value:'LOGIN'},
    {label:'查看',value:'VIEW'},
    {label:'修改',value:'UPDATE'},
    {label:'新增',value:'ADD'},
    {label:'删除',value:'DEL'},
    {label:'其他',value:'OTHER'},
    // {label:'无效请求',value:''},
]

//品牌
export const brand = [
    {value:'brand_oppein',label:"欧派"},
    {value:'brand_oboli',label:"欧铂丽"},
    {value:'brand_oboni',label:"欧铂尼"},
]
//品类
export const category = [
    {value:'category_chugui',label:"橱柜"},
    {value:'category_weiyu',label:"卫浴"},
    {value:'category_yigui',label:"集成家居"},
    {value:'category_mumen',label:"木门"},
    {value:'category_qiangshi',label:"墙饰"},
    {value:'category_bigFamily',label:"大家居"},
]
//部门类型
export const departType = [
    {value:'1',label:"欧派公司"},
    {value:'2',label:"商场"},
    {value:'3',label:"门店"},
    {value:'4',label:"部门"},
]
//表达式
export const expression = [
    {value:'=',label:"="},
    {value:'=<',label:"=<"},
    {value:'like',label:"like"},
    {value:'in',label:"in"},
    {value:'all',label:"all"},
]
//表达式标记
export const depatTag = [
    {value:'and',label:"and"},
    {value:'or',label:"or"},
]
//维度名称
export const vdoingName = [
    {value:'region_id',label:"区域"},
    {value:'department_id',label:"部门"},
    {value:'position_id',label:"职位"},
]

// 设计软件类型
export const externalSystem = [
    { value: 'caxa', label: 'CAXA', },
    { value: '3vjia', label: '三维家', },
    { value: 'zhouse', label: '知户型', },
    { value: 'dbj', label: '打扮家', },
];

export const externalSystemMap = externalSystem.reduce((prev, { value, label }) => {
    return { ...prev, [value]: label };
}, {});

// 根据设计软件类型code获取label
export const getExternalSystemLabel = value => {
    if (!value) return;

    let designTypeMap = externalSystemMap;

    if (sessionStorage.getItem('designType')) {
        designTypeMap = JSON.parse(sessionStorage.getItem('designType'))
            .map(({ code, name }) => ({ value: code.toLowerCase(), label: name }))
            .reduce((prev, { value, label }) => ({ ...prev, [value]: label }), {});
    }
    
    return designTypeMap[value.toLowerCase()]
}



// WEBPACK FOOTER //
// ./src/util/dict.js